import courierFilesEs from './es/courier-files.json';
import courierFilesEn from './en/courier-files.json';

export const codCourierFilesEs = courierFilesEs;
export const codCourierFilesEn = courierFilesEn;
